import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'cp-navigation-header-radius-container',
  imports: [],
  templateUrl: './navigation-header-radius-container.component.html',
  styleUrls: ['./navigation-header-radius-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationHeaderRadiusContainerComponent {}
